import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PortalServicePortalDto } from '@nx-frontend/shared/types';
import { GetWorkspaceParams } from '@nx-frontend/shared/types';
import { GetWorkspaceOptions } from '@nx-frontend/shared/types';

export async function getPortalByWorkspaceId(
  { workspaceId }: GetWorkspaceParams,
  options: GetWorkspaceOptions
): Promise<PortalServicePortalDto | null> {
  const { userId } = options;
  let portal: PortalServicePortalDto | null = null;
  try {
    const response = await axiosClient.get<PortalServicePortalDto>(
      `${generalEnv.portalServiceUrl}/v1/workspaces/${workspaceId}/portals`,
      {
        headers: {
          'Authorization': `Internal ${userId}:auto`,
          'x-secret': generalEnv.superSecret,
        },
      }
    );
    portal = response.data;
  } catch (err) {
    console.error(
      `getPortalByWorkspaceId error for workspace ${workspaceId}, user ${userId}, url ${generalEnv.portalServiceUrl}/v1/workspaces/${workspaceId}/portals: ${err}`
    );
  }

  return portal;
}
